import request from '@/utils/request'
// 任务详情
export function taskListData(data) {
  return request({
    url: '/sys/task/list',
    method: 'post',
    data
  })
}
// 任务删除
export function taskDelete(data) {
  return request({
    url: '/sys/task/delete',
    method: 'post',
    data
  })
}
// 查看详情
export function taskInfoData(id) {
  return request({
    url: `/sys/task/info/${id}`,
    method: 'get'
  })
}
// 任务修改
export function taskSaveData(data) {
  return request({
    url: '/sys/task/save',
    method: 'post',
    data
  })
}
// 任务添加
export function taskUpdateData(data) {
  return request({
    url: '/sys/task/update',
    method: 'post',
    data
  })
}